import React, {useEffect, useState} from 'react';
import {useNavigate, useParams} from "react-router";
import Busy from '../../components/Busy';
import {Button, Grid} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import {
  PaymentContainer,
  PaymentHeading,
  PaymentLpDivider,
  PaymentLpListingInfoSection,
  PaymentMainContainer,
  PaymentMainSection,
  PaymentSection
} from './style';
import {getErrorMessage} from '../../util/NetworkErrorUtil';
import {withSnackbar} from "../../components/hocs/withSnackbar";
import {verbiage} from "./booking-make-payment-verbiage";
import BuyerPaymentMethodSelect
  from "../../components/paymentMethods/buyerPaymentMethodSelect/BuyerPaymentMethodSelect";
import TransactionsList from "../../components/payments/failedPayments/TransactionsList";
import BookingPayment from "../../components/payments/bookingPayment/BookingPayment";
import {requestBookingById} from "../../components/payments/payment-requests";
import {BuyerBookingTabs} from "../../components/bookingsOverview/data";
import {updatePaymentMethod, requestRetryFailedTransactionsForBooking} from '../../components/bookedSpaces/request/booked-spaces-requests';
import {getRentalAgreementURL} from '../../util/BookingUtil';
import {toast} from "react-toastify";

const BookingMakePayment = ({account, snackbarShowMessage}) => {
  const {bookingId} = useParams();
  const navigate = useNavigate();

  const [paymentMethodId, setPaymentMethodId] = useState('');
  const [booking, setBooking] = useState([]);
  const [failedPaymentsTotal, setFailedPaymentsTotal] = useState({count: 0, charge: 0, tax: 0, transactionFee: 0, total: 0 });

  useEffect(() => {
    if (bookingId) {
      Busy.set(true)
      requestBookingById(bookingId)
        .then((response) => {
          setBooking(response?.body);
        })
        .catch((error) => {
          snackbarShowMessage(getErrorMessage(error, undefined, 'nonStandard'), 'error', 15000);
        }).finally(() => Busy.set(false));
    }
  }, [bookingId, snackbarShowMessage]);

  const returnToBookings = () => {
    navigate(`/bookings?status=${BuyerBookingTabs.PAYMENT_FAILED}`);
  };

  const handleMakePayment = () => {
    Busy.set(true)
    const bookingData = {
      bookingId: booking.id,
      buyerAccountId: account.id,
      paymentMethodId: paymentMethodId,
      tosDocUrl: getRentalAgreementURL(booking.supplierLegalAgreementFileName)
    }
    updatePaymentMethod(bookingData)
      .then(({body}) => {
        const {orderNumber, id} = body;
        return requestRetryFailedTransactionsForBooking(id)
          .then(() => {
            // use toast here instead of snackbar so that the message still displays when we redirect to the booking page
            toast.success(`Successfully updated payment method and retried failed invoices for booking ${orderNumber}.`);
            navigate(`/bookings?bookingNumber=${orderNumber}`);
          })
          .catch((err) => {
            snackbarShowMessage(
              `The payment method for booking ${orderNumber} was updated, but retrying the failed invoices failed: ${getErrorMessage(err, undefined, 'nonStandard')}`,
              "error"
            );
          });
      })
      .catch((err) => snackbarShowMessage(getErrorMessage(err, undefined, 'nonStandard'), "error"))
      .finally(() => Busy.set(false));
  }

  return (
    <PaymentMainSection component='section'>
      <PaymentContainer>
        <PaymentSection component='div'>
          <header>
            <PaymentHeading color={'textPrimary'} component={'h1'}>
              <Button sx={{ minWidth: '0em', padding: '0em', mr: 0.4 }} variant='text' onClick={returnToBookings} >
                <ArrowBackIcon />
              </Button>
              {verbiage.pageTitle}
            </PaymentHeading>
          </header>
          <PaymentLpDivider variant='fullWidth'/>
          <PaymentMainContainer item container>
            <PaymentLpListingInfoSection item container direction={'column'} xs>
              <BuyerPaymentMethodSelect
                account={account}
                setSelectedPaymentMethod={setPaymentMethodId}
              />
            </PaymentLpListingInfoSection>
            <Grid item xs={12} md={5}>
              <TransactionsList
                bookingId={bookingId}
                paymentMethodId={paymentMethodId}
                setPaymentsTotal={setFailedPaymentsTotal}
              />
            </Grid>
            <Grid item xs={12}>
              <BookingPayment
                account={account}
                booking={booking}
                paymentTotals={failedPaymentsTotal}
                paymentMethodId={paymentMethodId}
                handleMakePayment={handleMakePayment}
              />
            </Grid>
          </PaymentMainContainer>
        </PaymentSection>
      </PaymentContainer>
    </PaymentMainSection>
  );
};

export default withSnackbar(BookingMakePayment);
